/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_default_category_metadescription = /** @type {(inputs: { categoryName: NonNullable<unknown>, storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.categoryName} na ${i.storeName}`
};

const da_default_category_metadescription = /** @type {(inputs: { categoryName: NonNullable<unknown>, storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.categoryName} hos ${i.storeName}`
};

const de_default_category_metadescription = /** @type {(inputs: { categoryName: NonNullable<unknown>, storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.categoryName} bei ${i.storeName}`
};

const en_default_category_metadescription = /** @type {(inputs: { categoryName: NonNullable<unknown>, storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.categoryName} on ${i.storeName}`
};

const es_default_category_metadescription = /** @type {(inputs: { categoryName: NonNullable<unknown>, storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.categoryName} en ${i.storeName}`
};

const fr_default_category_metadescription = /** @type {(inputs: { categoryName: NonNullable<unknown>, storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.categoryName} sur ${i.storeName}`
};

const hu_default_category_metadescription = /** @type {(inputs: { categoryName: NonNullable<unknown>, storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.categoryName} a ${i.storeName} -on`
};

const it_default_category_metadescription = /** @type {(inputs: { categoryName: NonNullable<unknown>, storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.categoryName} su ${i.storeName}`
};

const nl_default_category_metadescription = /** @type {(inputs: { categoryName: NonNullable<unknown>, storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.categoryName} bij ${i.storeName}`
};

const pl_default_category_metadescription = /** @type {(inputs: { categoryName: NonNullable<unknown>, storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.categoryName} w ${i.storeName}`
};

const pt_default_category_metadescription = /** @type {(inputs: { categoryName: NonNullable<unknown>, storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.categoryName} na ${i.storeName}`
};

const sv_default_category_metadescription = /** @type {(inputs: { categoryName: NonNullable<unknown>, storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.categoryName} hos ${i.storeName}`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ categoryName: NonNullable<unknown>, storeName: NonNullable<unknown> }} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const default_category_metadescription = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.default_category_metadescription(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("default_category_metadescription", locale)
	if (locale === "cs") return cs_default_category_metadescription(inputs)
	if (locale === "da") return da_default_category_metadescription(inputs)
	if (locale === "de") return de_default_category_metadescription(inputs)
	if (locale === "en") return en_default_category_metadescription(inputs)
	if (locale === "es") return es_default_category_metadescription(inputs)
	if (locale === "fr") return fr_default_category_metadescription(inputs)
	if (locale === "hu") return hu_default_category_metadescription(inputs)
	if (locale === "it") return it_default_category_metadescription(inputs)
	if (locale === "nl") return nl_default_category_metadescription(inputs)
	if (locale === "pl") return pl_default_category_metadescription(inputs)
	if (locale === "pt") return pt_default_category_metadescription(inputs)
	return sv_default_category_metadescription(inputs)
};